module.exports = __webpack_public_path__ + "12e3597df050664c6aa4f5d76557841a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-2-s.png
// module id = 2854
// module chunks = 0